<template>
    <div class="examEntrance"
        :style="{ 'width': _isMobile() ? '100%' : '1200px', 'margin': _isMobile() ? '-28px auto' : '0 auto' }">
        <div class="mainContent" :style="{ borderRadius: _isMobile() ? '28px 28px 0 0' : 'none' }">
            <img src="../../assets/image/JXW.png" class="jxwLogo" alt="">
            <div class="maxButton" v-if="examinationInfo">
                <h1>{{ examinationInfo.paperName }}</h1>
            </div>
            <div class="minButton" @click="toPageFn()"  v-if="examinationInfo">
               {{ queryInfo.type == 'ZXKS' ? '进入考试' : '开始练习' }}  <i class="iconfont" style="font-size: 12px;">&#xe626;</i>
            </div>
            <a-empty description="暂无考试" v-else />

        </div>
    </div>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
import { getAction } from '@/api/manage'
export default {
    name: 'examEntrance',
    components: {},
    mixins: [mixinDevice],
    data() {
        return {
            queryInfo: {},
            examinationInfo: {}
        }
    },
    created() {
        this.queryInfo = this.$route.query;
        this.init(this.$route.query.paperType,this.$route.query.type)
    },
    mounted() { },
    methods: {
        init(paperType,type) {
            let isSimulation = type == 'ZXKS' ? 0 : type == 'ZXLX' ? 1 : 2
            getAction(`/teaching/teachingPaper/minePaperList?paperType=${paperType}&pageSize=999&isSimulation=${isSimulation}`).then(res => {
                if (res.success) {
                    this.examinationInfo = res.result[0]
                }
            })
        },
        toPageFn() {
            let _this = this
            let url = this.queryInfo.type == 'ZXKS' ? '/examination/index' : '/examination/Workbook'
            this.$router.push({
                path: url, query: {
                    paperDeptId: this.examinationInfo.paperDeptId,
                    paperId: this.examinationInfo.paperId,
                    departId: this.examinationInfo.departId,
                }
            });
        }
    }
}
</script>
<style lang='scss' scoped>
.examEntrance {
    width: 100%;
    margin: -28px auto;

    .mainContent {
        width: 100%;
        background: #fff;
        position: relative;
        padding: 64px 0;

        .jxwLogo {
            width: 67px;
            height: 70px;
            position: absolute;
            top: -31px;
            right: 13px;
            z-index: 9;
        }

        .maxButton {
            width: 237px;
            height: 237px;
            background: linear-gradient(180deg, #F15051 24%, #FCB8B7 100%);
            border-radius: 50%;
            margin: 0 auto;
            box-shadow: 0 0 10px #FCB8B7;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            h1 {
                font-weight: bold;
                font-size: 23px;
                color: #fff;
                margin: 0;
            }

            h5 {
                font-size: 12px;
                color: #fff;
            }
        }

        .minButton {
            width: 120px;
            height: 38px;
            background: #f87c7898;
            box-shadow: 1px 2px 7px 0px rgba(0, 0, 0, 0.34);
            text-align: center;
            line-height: 38px;
            font-size: 13px;
            color: #fff;
            cursor: pointer;
            margin: 50px auto;
            border-radius: 5px;
        }

    }

}
</style>
  